// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/product-sans/ProductSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/product-sans/ProductSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/product-sans/ProductSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/product-sans/ProductSans-Black.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'ProductSans-Light';
    font-style: normal;
    font-weight: 100 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
    font-display: swap;
}
@font-face {
    font-family: 'ProductSans-Medium';
    font-style: normal;
    font-weight: 100 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
    font-display: swap;
}

@font-face {
    font-family: 'ProductSans-Bold';
    font-style: normal;
    font-weight: 100 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
    font-display: swap;
}

@font-face {
    font-family: 'ProductSans-Black';
    font-style: normal;
    font-weight: 100 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
    font-display: swap;
}`, "",{"version":3,"sources":["webpack://./src/css/product-sans.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,+DAA+E;IAC/E,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,oBAAoB;IACpB,+DAAgF;IAChF,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,oBAAoB;IACpB,+DAA8E;IAC9E,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,+DAA+E;IAC/E,kBAAkB;AACtB","sourcesContent":["@font-face {\r\n    font-family: 'ProductSans-Light';\r\n    font-style: normal;\r\n    font-weight: 100 700;\r\n    src: url(../assets/fonts/product-sans/ProductSans-Light.otf) format('opentype');\r\n    font-display: swap;\r\n}\r\n@font-face {\r\n    font-family: 'ProductSans-Medium';\r\n    font-style: normal;\r\n    font-weight: 100 700;\r\n    src: url(../assets/fonts/product-sans/ProductSans-Medium.otf) format('opentype');\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'ProductSans-Bold';\r\n    font-style: normal;\r\n    font-weight: 100 700;\r\n    src: url(../assets/fonts/product-sans/ProductSans-Bold.otf) format('opentype');\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'ProductSans-Black';\r\n    font-style: normal;\r\n    font-weight: 100 700;\r\n    src: url(../assets/fonts/product-sans/ProductSans-Black.otf) format('opentype');\r\n    font-display: swap;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
